import React from "react";
import "./AddMember.css";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { isValidPhoneNumber } from "libphonenumber-js";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../../Redux/Actions/alert.action";
import httpPathName from "Global/Config/Config";
import { setRelData } from "../../../Redux/Actions/set.action";

const EditMember = ({ show, setShow, data }) => {
  const { fullName, relationship, mobileNumber, gender, age } = data
    ? data
    : "";

  const dispatch = useDispatch();

  const token = localStorage.getItem("access_token");
  const userId = useSelector((state) => state.setUserDataReducer);
  console.log("userid",userId)

  const [formData, setFormData] = useState({
    userId,
    fullName: fullName,
    relationship: relationship,
    mobileNumber: mobileNumber,
    gender: gender,
    age: age,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getRelationshipData = async () => {
    const apiStatus = await httpPathName
      .get("users/relationships", { headers: { "x-auth-token": token } })
      .then((response) => {
        dispatch(setRelData(response?.data?.relationship))
        //setData(response?.data?.relationship)
        // dispatch(setAlert("success", "Order Data Fetched Successfully"));
      })
      .catch((err) => {
        console.log(err);
        dispatch(setAlert("error", err?.response?.data?.message));
      });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    delete formData.userId
    if (
      formData?.mobileNumber &&
      !isValidPhoneNumber(`+${formData?.mobileNumber}`)
    ) {
      dispatch(setAlert("error", "Please enter a valid mobile number"));
    } else if (Object.keys(formData).length < 5) {
      dispatch(setAlert("error", "All fields are required!"));
    } else {
      const promise = await httpPathName
        .put(
          `users/update-relation/${data?._id}`,
          { ...formData },
          { headers: { "x-auth-token": token } }
        )
        .then((response) => {
          dispatch(setAlert("success", response?.data?.message));
          setShow(false);
          getRelationshipData()
        })
        .catch((err) => {
          console.log(err);
          dispatch(setAlert("error", err?.response?.data?.message));
        });
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
      }}
      centered
      className="add-member"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Member</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <label htmlFor="full-name">Full Name</label>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              id="full-name"
              name="fullName"
              value={formData?.fullName}
              type="text"
              placeholder="Full Name"
              autoComplete="off"
              onChange={(e) => handleChange(e)}
            />
          </div>

          <label htmlFor="mobile">Mobile Number</label>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18.9214 4.08C17.3214 2.48 14.9814 1.87 12.8014 2.49C12.4014 2.6 12.1714 3.02 12.2814 3.42C12.3914 3.82 12.8114 4.05 13.2114 3.94C14.8614 3.47 16.6514 3.94 17.8614 5.15C19.0814 6.37 19.5414 8.15 19.0714 9.8C18.9614 10.2 19.1914 10.61 19.5914 10.73C19.6614 10.75 19.7314 10.76 19.7914 10.76C20.1214 10.76 20.4214 10.54 20.5114 10.21C21.1314 8.03 20.5114 5.69 18.9214 4.09V4.08Z"
                fill="#2A364E"
              />
              <path
                d="M16.0486 10.6C16.1786 10.7 16.3386 10.75 16.4986 10.75C16.7286 10.75 16.9486 10.65 17.0986 10.45C18.0686 9.17 17.9386 7.34 16.7986 6.2C15.6586 5.06 13.8386 4.93 12.5486 5.9C12.2186 6.15 12.1486 6.62 12.3986 6.95C12.6486 7.28 13.1186 7.35 13.4486 7.1C14.1386 6.58 15.1186 6.65 15.7386 7.26C16.3586 7.87 16.4186 8.86 15.8986 9.55C15.6486 9.88 15.7186 10.35 16.0486 10.6ZM15.3186 14.11C14.9386 13.81 14.4386 13.71 13.9686 13.84L12.4186 14.29C11.7486 13.64 11.1186 12.95 10.5486 12.22C9.89859 11.39 9.30859 10.5 8.79859 9.57L9.60859 8.16C9.85859 7.73 9.86859 7.2 9.64859 6.76L7.95859 3.36C7.60859 2.64 6.74859 2.34 6.01859 2.66C5.48859 2.89 4.97859 3.18 4.49859 3.51C4.02859 3.83 3.58859 4.2 3.18859 4.6C2.85859 4.93 2.70859 5.4 2.77859 5.87C3.12859 8.15 4.06859 11.56 6.56859 14.88C9.24859 18.45 12.5286 20.35 14.8086 21.31C14.9986 21.39 15.1986 21.43 15.3886 21.43C15.6986 21.43 16.0086 21.33 16.2786 21.13C16.8286 20.72 17.3386 20.23 17.7886 19.7C18.1286 19.29 18.4286 18.86 18.6986 18.4C19.0586 17.77 18.9086 16.97 18.3286 16.51L15.3186 14.1V14.11ZM16.6486 18.75C16.2786 19.19 15.8586 19.59 15.3986 19.94C13.2886 19.05 10.2486 17.29 7.76859 13.99C5.45859 10.92 4.58859 7.76 4.26859 5.65C4.59859 5.32 4.96859 5.02 5.34859 4.75C5.74859 4.47 6.17859 4.23 6.61859 4.03L8.30859 7.42L7.28859 9.19C7.15859 9.41 7.15859 9.68 7.27859 9.91C7.87859 11.05 8.57859 12.14 9.36859 13.15C10.0786 14.06 10.8686 14.91 11.7086 15.69C11.8986 15.87 12.1786 15.93 12.4286 15.86L14.3786 15.29L17.3986 17.67C17.1786 18.05 16.9286 18.42 16.6486 18.75Z"
                fill="#2A364E"
              />
            </svg>
            <input
              id="mobile"
              name="mobileNumber"
              value={formData?.mobileNumber}
              autoComplete="off"
              type="tel"
              placeholder="Mobile Number"
              onChange={(e) => handleChange(e)}
            />
          </div>

          <label htmlFor="gender">Gender</label>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <select
              id="gender"
              name="gender"
              value={formData?.gender}
              type="text"
              onChange={(e) => handleChange(e)}
              defaultValue={"none"}
            >
              <option value="none">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Others">Other</option>
            </select>
          </div>

          <label htmlFor="relationship">Relationship</label>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                stroke="#2A364E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              id="relationship"
              name="relationship"
              value={formData?.relationship}
              autoComplete="off"
              type="text"
              placeholder="Relationship"
              onChange={(e) => handleChange(e)}
            />
          </div>

          <label htmlFor="age">Age</label>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.7086 13.73L19.4586 12.4C19.2861 11.3855 18.8899 10.4222 18.2986 9.57999C17.2437 8.13343 15.7383 7.0782 14.0186 6.57999C13.9665 6.01417 13.7231 5.48301 13.3287 5.07401C12.9342 4.66502 12.4122 4.4026 11.8486 4.32999C11.8486 4.32999 11.8486 4.23999 11.8486 4.19999C11.8686 4.05855 11.9418 3.93008 12.0533 3.84085C12.1649 3.75163 12.3063 3.70839 12.4486 3.71999C12.6462 3.74784 12.8468 3.69605 13.0062 3.57603C13.1656 3.45601 13.2708 3.27758 13.2986 3.07999C13.3265 2.8824 13.2747 2.68185 13.1547 2.52244C13.0347 2.36304 12.8562 2.25784 12.6586 2.22999C12.1533 2.16744 11.6426 2.2943 11.2253 2.58607C10.8079 2.87785 10.5134 3.31387 10.3986 3.80999C10.3359 4.06516 10.3057 4.32724 10.3086 4.58999C9.93533 4.78861 9.61901 5.07938 9.38973 5.43468C9.16045 5.78998 9.02582 6.19801 8.99864 6.61999C7.27901 7.1182 5.77354 8.17343 4.71864 9.61999C4.12572 10.4486 3.72282 11.3978 3.53864 12.4L3.28864 13.73C3.22084 14.1096 3.24248 14.4997 3.35184 14.8695C3.46121 15.2392 3.65528 15.5784 3.91864 15.86C4.12636 16.0794 4.36981 16.262 4.63864 16.4C4.63864 16.78 4.63864 17.16 4.63864 17.54C4.72366 18.3745 4.89114 19.1985 5.13864 20C5.37423 20.5528 5.77631 21.0185 6.28891 21.3321C6.80152 21.6458 7.39915 21.7919 7.99864 21.75H14.9986C15.5981 21.7919 16.1958 21.6458 16.7084 21.3321C17.221 21.0185 17.623 20.5528 17.8586 20C18.0907 19.2069 18.2447 18.393 18.3186 17.57C18.3186 17.2 18.3186 16.81 18.3186 16.43C18.5875 16.292 18.8309 16.1094 19.0386 15.89C19.3136 15.6089 19.5177 15.2664 19.6342 14.8908C19.7507 14.5152 19.7762 14.1174 19.7086 13.73ZM12.5386 6.80999C12.5386 7.08581 12.4291 7.35034 12.234 7.54538C12.039 7.74042 11.7745 7.84999 11.4986 7.84999C11.2228 7.84999 10.9583 7.74042 10.7632 7.54538C10.5682 7.35034 10.4586 7.08581 10.4586 6.80999C10.4586 6.53416 10.5682 6.26964 10.7632 6.0746C10.9583 5.87956 11.2228 5.76999 11.4986 5.76999C11.7745 5.76999 12.039 5.87956 12.234 6.0746C12.4291 6.26964 12.5386 6.53416 12.5386 6.80999ZM4.99864 12.68C5.13346 11.8833 5.44061 11.1257 5.89864 10.46C6.7605 9.32262 7.96729 8.4947 9.33864 8.09999C9.56983 8.46342 9.88899 8.76265 10.2666 8.96995C10.6441 9.17726 11.0679 9.28594 11.4986 9.28594C11.9294 9.28594 12.3532 9.17726 12.7307 8.96995C13.1083 8.76265 13.4274 8.46342 13.6586 8.09999C15.0263 8.49664 16.2294 9.32438 17.0886 10.46C17.5467 11.1257 17.8538 11.8833 17.9886 12.68L18.2286 14C18.2538 14.1521 18.2434 14.308 18.1983 14.4555C18.1532 14.6029 18.0746 14.7379 17.9686 14.85C17.8319 14.9953 17.6629 15.1063 17.4752 15.174C17.2876 15.2418 17.0866 15.2644 16.8886 15.24C16.6438 15.2118 16.4076 15.1322 16.1957 15.0064C15.9837 14.8806 15.8007 14.7114 15.6586 14.51C15.5845 14.4002 15.4826 14.312 15.3633 14.2544C15.2441 14.1968 15.1116 14.1718 14.9796 14.1819C14.8475 14.1921 14.7204 14.237 14.6114 14.3122C14.5023 14.3874 14.4151 14.4902 14.3586 14.61C14.2479 14.801 14.0889 14.9595 13.8976 15.0697C13.7063 15.1799 13.4894 15.2379 13.2686 15.2379C13.0479 15.2379 12.831 15.1799 12.6397 15.0697C12.4484 14.9595 12.2894 14.801 12.1786 14.61C12.1108 14.4893 12.0121 14.3888 11.8926 14.3189C11.7731 14.2489 11.6371 14.2121 11.4986 14.2121C11.3602 14.2121 11.2242 14.2489 11.1047 14.3189C10.9852 14.3888 10.8865 14.4893 10.8186 14.61C10.7079 14.801 10.5489 14.9595 10.3576 15.0697C10.1663 15.1799 9.94941 15.2379 9.72864 15.2379C9.50787 15.2379 9.29097 15.1799 9.09967 15.0697C8.90837 14.9595 8.74939 14.801 8.63864 14.61C8.58217 14.4902 8.49497 14.3874 8.3859 14.3122C8.27684 14.237 8.1498 14.1921 8.01772 14.1819C7.88564 14.1718 7.75323 14.1968 7.63394 14.2544C7.51466 14.312 7.41278 14.4002 7.33864 14.51C7.19395 14.7133 7.00767 14.8836 6.79216 15.0094C6.57665 15.1353 6.33684 15.2139 6.08864 15.24C5.88894 15.2686 5.68528 15.248 5.49533 15.18C5.30539 15.112 5.1349 14.9988 4.99864 14.85C4.89798 14.7353 4.82491 14.599 4.78504 14.4517C4.74518 14.3043 4.73957 14.1498 4.76864 14L4.99864 12.68ZM16.4086 19.55C16.256 19.7924 16.0379 19.9867 15.7796 20.1106C15.5213 20.2344 15.2332 20.2828 14.9486 20.25H7.99864C7.71405 20.2828 7.42599 20.2344 7.16768 20.1106C6.90936 19.9867 6.6913 19.7924 6.53864 19.55C6.33619 18.8513 6.20223 18.1346 6.13864 17.41C6.13864 17.18 6.13864 16.96 6.13864 16.73H6.24864C6.84429 16.6719 7.41041 16.4427 7.87864 16.07C8.3925 16.4667 9.02118 16.686 9.67031 16.6951C10.3194 16.7041 10.954 16.5023 11.4786 16.12C12.0005 16.5104 12.6373 16.7164 13.2889 16.7055C13.9405 16.6947 14.5701 16.4676 15.0786 16.06C15.5586 16.4356 16.1331 16.671 16.7386 16.74H16.8186C16.8186 16.96 16.8186 17.19 16.8186 17.41C16.7551 18.1346 16.6211 18.8513 16.4186 19.55H16.4086Z"
                fill="#2A364E"
              />
            </svg>
            <input
              id="age"
              name="age"
              value={formData?.age}
              autoComplete="off"
              type="number"
              placeholder="Age"
              onChange={(e) => handleChange(e)}
            />
          </div>

          <button type="submit">Update member</button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditMember;
